import { render, staticRenderFns } from "./UserReports.vue?vue&type=template&id=6fb08f61&"
import script from "./UserReports.vue?vue&type=script&lang=js&"
export * from "./UserReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports